// extracted by mini-css-extract-plugin
module.exports = {"footerCardsContainer":"_8goSD","left":"_3bX66","right":"ZE5rw"};